<template>
    <div class="monthly-closing-container">
        <div class="column">

            <div class="item" v-for="(item, index) in workTimeItems" v-show="item.show" :key="'wt-'+index" v-bind:style="{flex: '1 1 calc(' + (100 / columns) + '% - 5px)', maxWidth: 'calc(' + (100 / columns) + '% - 5px)'}">
                <labelc :text="item.label" :styleText="item.styleText ? item.styleText : null" :components="item.components ? item.components: null"  />
                <labelc :text="(employeeData ? (item.displayLabel(employeeData[item.key])) : 0).toFixed(2)" :styleText="item.styleText ? item.styleText : null" />
            </div>

        </div>
        <div class="column">

            <div class="item" v-for="(item, index) in vacationItems" :key="'vt-'+index" v-bind:style="{flex: '1 1 calc(' + (100 / columns) + '% - 5px)', maxWidth: 'calc(' + (100 / columns) + '% - 5px)'}">
                <labelc :text="item.label"/>
                <labelc :text="(employeeData ? (item.displayLabel(employeeData[item.key])) : 0).toFixed(2)"/>
            </div>
        </div>

        <div class="column">

            <div class="item" v-for="(item, index) in holidayItems" :key="'ht-'+index" v-bind:style="{flex: '1 1 calc(' + (100 / columns) + '% - 5px)', maxWidth: 'calc(' + (100 / columns) + '% - 5px)'}">
                <labelc :text="item.label"/>
                <labelc :text="(employeeData ? (item.displayLabel(employeeData[item.key])) : 0).toFixed(2)"/>
            </div>
        </div>
        <div class="column">

            <div class="item" v-for="(item, index) in nightWorkItems" :key="'nt-'+index" v-bind:style="{flex: '1 1 calc(' + (100 / columns) + '% - 5px)', maxWidth: 'calc(' + (100 / columns) + '% - 5px)'}">
                <labelc :text="item.label"/>
                <labelc :text="(employeeData ? (item.displayLabel(employeeData[item.key])) : 0).toFixed(2)"/>
            </div>
        </div>
        <div class="column">

            <div class="item" v-for="(item, index) in overTimeItems" :key="'ot-'+index" v-bind:style="{flex: '1 1 calc(' + (100 / columns) + '% - 5px)', maxWidth: 'calc(' + (100 / columns) + '% - 5px)'}">
                <labelc :text="item.label"/>
                <labelc :text="(employeeData ? (item.displayLabel(employeeData[item.key])) : 0).toFixed(2)"/>
            </div>
        </div>



    </div>
</template>

<script>
    export default {
        name: "monthlyClosingSummary",
        data(){
            return {
                columns: 1,
                showActualWorkTimeBreakdown: false,
                showUnproductiveWorkTimeBreakdown: false,
            }
        },
        props:{
            employeeData: Object,
            prevMonthWorkBalance: Object,
            enableWorkBalanceMultiplier: Boolean,
            optionalColumn: Boolean,
        },
        computed: {
            workTimeItems() {
                let view = this;
                let showActualItems = view.showActualWorkTimeBreakdown;
                let showUnproductiveItems = view.showActualWorkTimeBreakdown && view.showUnproductiveWorkTimeBreakdown;
                let items = [

                    {label: this.$t('comp.view.target'), value: 0, key: 'workTimeRegular', displayLabel: (val) => {return (val/60.0)}, show: true},
                    {label: this.$t('comp.view.actual'), value: 0, key: 'totalWorkTime',
                    displayLabel: (val) => {
                        return (view.employeeData.prevMonthTime + view.employeeData.workTime + view.employeeData.unproductiveWorkTime)/ 60;
                    },
                    show: true,
                    styleText: view.showActualWorkTimeBreakdown ? {color: "var(--contrast-6)"} : null,
                    components: [
                        {
                        type: 'buttonc',
                        propContainer: {type: 'button icon-overlay square', icon: 'fa-info-circle'},
                        customEvents:{ click: (event) => {
                            view.showActualWorkTimeBreakdown = !view.showActualWorkTimeBreakdown;
                        }},
                        }
                    ]},
                    {label: this.$t('comp.view.prevMonthTransfer'), value: 0, key: 'prevMonthTime', displayLabel: (val) => {return (val/60.0)}, show: showActualItems},
                    {label: this.$t('comp.view.productiveWorkTime'), value: 0, key: 'workTime', displayLabel: (val) => {return (val/60.0)}, show: showActualItems},
                    {label: this.$t('comp.view.unproductiveWorkTime'), value: 0, key: 'unproductiveWorkTime', displayLabel: (val) => {return (val/60.0)},
                    show: showActualItems,
                    styleText: showUnproductiveItems ? {color: "var(--contrast-6)"} : null,
                    components: [
                        {
                        type: 'buttonc',
                        propContainer: {type: 'button icon-overlay square', icon: 'fa-info-circle'},
                        customEvents:{ click: (event) => {
                            view.showUnproductiveWorkTimeBreakdown = !view.showUnproductiveWorkTimeBreakdown;
                        }},
                        }
                    ]},

                    {label: this.$t('report.comp.sickLeave'), value: 0, key: 'sickWorkTime', displayLabel: (val) => {return (val/60.0)}, show: showUnproductiveItems},
                    {label: this.$t('report.comp.continuedPay'), value: 0, key: 'wageContinuationWorkTime', displayLabel: (val) => {return (val/60.0)}, show: showUnproductiveItems},
                    {label: this.$t('employee.comp.education'), value: 0, key: 'educationWorkTime', displayLabel: (val) => {return (val/60.0)}, show: showUnproductiveItems},
                    {label: this.$t('report.comp.careLeave'), value: 0, key: 'nursingVacationWorkTime', displayLabel: (val) => {return (val/60.0)}, show: showUnproductiveItems},
                    {label: this.$t('report.comp.vacation'), value: 0, key: 'vacationWorkTime', displayLabel: (val) => {return (val/60.0)}, show: showUnproductiveItems},
                    {label: this.$t('report.comp.otherAbsences'), value: 0, key: 'miscWorkTime', displayLabel: (val) => {return (val/60.0)}, show: showUnproductiveItems},
                    {label: this.$t('comp.view.modifiedWorkTime'), value: 0, key: 'paidWorkTime', displayLabel: (val) => {return (val/60.0)}, show: true},



                ];
                if(this.enableWorkBalanceMultiplier){
                    items = items.concat(
                        [
                            {label: this.$t('comp.view.multiplier'), value: 0, key: 'multiplier', displayLabel: (val) => {return (val/100.0)}, show: true},
                            {label: this.$t('comp.view.accountingPeriodCarryover'), value: 0, key: 'accountingPeriodBalance', displayLabel: (val) => {return (val/60.0)}, show: true},

                        ]
                    )
                }
                return items;
            },
            vacationItems(){
                let view = this;
                let items = [
                   {label: this.$t('comp.view.prevMonthVacation'), value: 0, key: 'prevMonthVacation', displayLabel: (val) => {
                        let prevMonthVacation = view.prevMonthWorkBalance ? view.prevMonthWorkBalance.vacationTimeBalance : 0;

                        return (prevMonthVacation/60.0/24)
                    }},
                    {label: this.$t('comp.view.vacationIncrease'), value: 0, key: 'contractVacation', displayLabel: (val) => {
                        let prevMonthVacation = view.prevMonthWorkBalance ? view.prevMonthWorkBalance.vacationTimeBalance : 0;

                        return (view.employeeData.vacationTimeBalance - prevMonthVacation + view.employeeData.vacationTime)/60.0/24;
                    }},
                    {label: this.$t('comp.view.vacationDays'), value: 0, key: 'vacationTime', displayLabel: (val) => {return (val/60.0/24)}},
                    {label: this.$t('comp.view.modifiedVacation'), value: 0, key: 'paidVacationTime', displayLabel: (val) => {return (val/60.0/24)}},



                ];
                return items;
            },
            holidayItems() {
                let view = this;
                let items = [
                    {label: this.$t('comp.view.prevMonthHolidayWork'), value: 0, key: 'prevMonthHolidayTime', displayLabel: (val) => {
                        let prevMonthHoliday = view.prevMonthWorkBalance ? view.prevMonthWorkBalance.holidayTimeBalance : 0;

                        return (prevMonthHoliday/60.0)
                    }},
                    {label: this.$t('comp.view.holidayWork'), value: 0, key: 'holidayTime', displayLabel: (val) => {return (val/60.0)}},
                    {label: this.$t('comp.view.holidayAdjustment'), value: 0, key: 'holidayAdjustmentWorkTime', displayLabel: (val) => {return (val/60.0)}},
                    {label: this.$t('comp.view.modifiedHolidays'), value: 0, key: 'paidHolidayTime', displayLabel: (val) => {return (val/60.0)}},



                ];
                return items;
            },
            nightWorkItems(){
                let view = this;
                let items = [
                    {label: this.$t('comp.view.prevMonthNightWork'), value: 0, key: 'prevMonthNightWorkTime', displayLabel: (val) => {return (val/60.0)}},
                    {label: this.$t('comp.view.nightWork'), value: 0, key: 'nightWorkTime', displayLabel: (val) => {return (val/60.0)}},
                    {label: this.$t('comp.view.nightWorkCount'), value: 0, key: 'nightWorkCount', displayLabel: (val) => {return (val)}},
                    {label: this.$t('comp.view.modifiedNightWork'), value: 0, key: 'paidNightWorkTime', displayLabel: (val) => {return (val/60.0)}},



                ];
                return items;
            },
            overTimeItems() {
                let view = this;
                let items = [
                    {label: this.$t('comp.view.prevMonthOvertime'), value: 0, key: 'prevMonthOverTime', displayLabel: (val) => {return (val/60.0)}},
                    {label: this.$t('comp.view.overtime'), value: 0, key: 'overTime', displayLabel: (val) => {return (val/60.0)}},
                    {label: this.$t('comp.view.overtimeCount'), value: 0, key: 'overTimeCount', displayLabel: (val) => {return (val)}},
                    {label: this.$t('comp.view.modifiedOvertime'), value: 0, key: 'paidOverTime', displayLabel: (val) => {return (val/60.0)}},
                ];
                return items;
            },
            items(){
                let view = this;
                let items = [
                    {label: this.$t('comp.view.prevMonthTransfer'), value: 0, key: 'prevMonthTime', displayLabel: (val) => {return (val/60.0)}},
                    {label: this.$t('comp.view.target'), value: 0, key: 'workTimeRegular', displayLabel: (val) => {return (val/60.0)}},
                    {label: this.$t('comp.view.actual'), value: 0, key: 'totalWorkTime', displayLabel: (val) => {
                        return (view.employeeData.prevMonthTime + view.employeeData.workTime + view.employeeData.unproductiveWorkTime)/ 60;
                    }},
                    {label: this.$t('comp.view.productiveWorkTime'), value: 0, key: 'workTime', displayLabel: (val) => {return (val/60.0)}},
                    {label: this.$t('comp.view.unproductiveWorkTime'), value: 0, key: 'unproductiveWorkTime', displayLabel: (val) => {return (val/60.0)}},

                    {label: this.$t('report.comp.sickLeave'), value: 0, key: 'sickWorkTime', displayLabel: (val) => {return (val/60.0)}},
                    {label: this.$t('report.comp.continuedPay'), value: 0, key: 'wageContinuationWorkTime', displayLabel: (val) => {return (val/60.0)}},
                    {label: this.$t('employee.comp.education'), value: 0, key: 'educationWorkTime', displayLabel: (val) => {return (val/60.0)}},
                    {label: this.$t('report.comp.careLeave'), value: 0, key: 'nursingVacationWorkTime', displayLabel: (val) => {return (val/60.0)}},
                    {label: this.$t('report.comp.vacation'), value: 0, key: 'vacationWorkTime', displayLabel: (val) => {return (val/60.0)}},
                    {label: this.$t('report.comp.otherAbsences'), value: 0, key: 'miscWorkTime', displayLabel: (val) => {return (val/60.0)}},
                    {label: this.$t('comp.view.modifiedWorkTime'), value: 0, key: 'paidWorkTime', displayLabel: (val) => {return (val/60.0)}},



                ];
                if(this.enableWorkBalanceMultiplier){
                    items = items.concat(
                        [
                            {label: this.$t('comp.view.accountingPeriodCarryover'), value: 0, key: 'accountingPeriodBalance', displayLabel: (val) => {return (val/60.0)}},
                            {label: this.$t('comp.view.multiplier'), value: 0, key: 'multiplier', displayLabel: (val) => {return (val/100.0)}},
                        ]
                    )
                }
                items = items.concat(
                    [
                        {label: this.$t('comp.view.prevMonthVacation'), value: 0, key: 'prevMonthVacation', displayLabel: (val) => {
                            let prevMonthVacation = view.prevMonthWorkBalance ? view.prevMonthWorkBalance.vacationTimeBalance : 0;

                            return (prevMonthVacation/60.0/24)
                        }},
                        {label: this.$t('comp.view.vacationIncrease'), value: 0, key: 'contractVacation', displayLabel: (val) => {
                            let prevMonthVacation = view.prevMonthWorkBalance ? view.prevMonthWorkBalance.vacationTimeBalance : 0;

                            return (view.employeeData.vacationTimeBalance - prevMonthVacation + view.employeeData.vacationTime)/60.0/24;
                        }},
                        {label: this.$t('comp.view.vacationDays'), value: 0, key: 'vacationTime', displayLabel: (val) => {return (val/60.0/24)}},
                        {label: this.$t('comp.view.modifiedVacation'), value: 0, key: 'paidVacationTime', displayLabel: (val) => {return (val/60.0/24)}},


                        {label: this.$t('comp.view.holidayWorkTime'), value: 0, key: 'holidayTime', displayLabel: (val) => {return (val/60.0)}},
                        {label: this.$t('comp.view.holidayAdjustment'), value: 0, key: 'holidayAdjustmentWorkTime', displayLabel: (val) => {return (val/60.0)}},
                        {label: this.$t('comp.view.modifiedHolidays'), value: 0, key: 'paidHolidayTime', displayLabel: (val) => {return (val/60.0)}},


                        {label: this.$t('comp.view.prevMonthNightWork'), value: 0, key: 'prevMonthNightWorkTime', displayLabel: (val) => {return (val/60.0)}},
                        {label: this.$t('comp.view.nightWork'), value: 0, key: 'nightWorkTime', displayLabel: (val) => {return (val/60.0)}},
                        {label: this.$t('comp.view.nightWorkCount'), value: 0, key: 'nightWorkCount', displayLabel: (val) => {return (val)}},
                        {label: this.$t('comp.view.modifiedNightWork'), value: 0, key: 'paidNightWorkTime', displayLabel: (val) => {return (val/60.0)}},


                        {label: this.$t('comp.view.prevMonthOvertime'), value: 0, key: 'prevMonthOverTime', displayLabel: (val) => {return (val/60.0)}},
                        {label: this.$t('comp.view.overtime'), value: 0, key: 'overTime', displayLabel: (val) => {return (val/60.0)}},
                        {label: this.$t('comp.view.overtimeCount'), value: 0, key: 'overTimeCount', displayLabel: (val) => {return (val)}},
                        {label: this.$t('comp.view.modifiedOvertime'), value: 0, key: 'paidOverTime', displayLabel: (val) => {return (val/60.0)}},
                    ]
                )
                return items;
            }
        }
    }
</script>

<style scoped>
.monthly-closing-container{
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: fit-content;
    background: #ec5580;
    display: flex;
    flex-wrap: wrap
}

.column {
  flex: 1 1 auto;
  width: 15%;
}
.small-column {
    flex: 1 1 auto;
    width: 10%;
}

.item{

    height: 40px;
    margin: 2.5px 2.5px;
    background: #fad0dc;
    position: relative;
    display: flex;
    flex-grow: unset;
}

.item .label:first-child{
    position: absolute;;
    left: 5px;
    top: 0;
    bottom: 0;
    margin: auto;
}

.item .label:last-child{
    position: absolute;;
    right: 5px;
    top: 0;
    bottom: 0;
    margin: auto;
    font-weight: 200;
    font-family: DistrictProThin;
}


</style>
